import { UserState } from "context/UserContext";
import { User } from "models/User";
import { useState } from "react";

interface IUserProps {
  error: unknown;
  userLoading: Boolean;
  updateUser: (user:User) => void;
  addUser: (user:User) => void;
  getUser: () => User | null;
} 

const useUserData = (): IUserProps => {
  const [error] = useState<unknown>();
  const [userLoading, setUserLoading] = useState(true);
  const { stateUser } = UserState();

  const updateUser = async({...user}:User) => {
    stateUser.updateUser(user);
    setUserLoading(false);
  }

  const addUser = async({...user}:User) => {
    stateUser.addUser(user);
    setUserLoading(false);
  }

  const getUser = () => {
    return stateUser.user;
  }

  return { error, userLoading, updateUser, addUser, getUser };
};

export default useUserData;